import React from "react"
import { Link } from "gatsby"
import { IconLogo } from "../components/icons"
import "../styles/styles.sass"

export default function Header() {
  return <div>
    <div className="bannerHeader">
      <div className="bannerContent">
        <p className={"bannerMessage"}>
          We are excited to announce that CueHit has joined the NEOGOV family as a part of the Power Products for Public Safety. Read more here:  <a className={"bannerLink"} href="https://www.powerdms.com/why-powerdms/2022-new-products">https://www.powerdms.com/why-powerdms/2022-new-products</a>
        </p>
      </div>
    </div>
    <header className="landingHeader">
      <div className="headerContent">
        <Link to="/" className="logo">
          <img src="/imageNewLogo.png"
               alt=""
               width="100%" height="auto"
          />
        </Link>

        <div className="industries navigationControl">

          {/*<div className="navigationItem navigationSolutions">*/}
          {/*  <Link to="/pricing/" className="navigationSegment" activeClassName="selected">*/}
          {/*    <div className="navigationTitle">Pricing</div>*/}
          {/*  </Link>*/}
          {/*</div>*/}

          <div className="navigationItem navigationIndustry911">
            <Link to="/911/" className="navigationSegment" activeClassName="selected">
              <div className="navigationTitle">911</div>
            </Link>

            <div className="navigationDropDown">
              <div className="dropDownTip"/>
              <div className="dropDownUsabilityFillter"/>
              <Link to="/911/#feature1" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Automatic Text Notifications from CAD</div>
              </Link>
              <Link to="/911/#feature2" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Surveys After 911 Calls</div>
              </Link>
              <Link to="/911/#feature3" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Positive Citizen Feedback</div>
              </Link>
              <Link to="/911/#feature4" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Data Analytics and Dashboards</div>
              </Link>
              <Link to="/911/#feature5" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Citizen Positive Satisfaction Score</div>
              </Link>
            </div>
          </div>

          <div className="navigationItem navigationIndustryLaw">
            <Link to="/law-enforcement/" className="navigationSegment" activeClassName="selected">
              <div className="navigationTitle">Law&nbsp;Enforcement</div>
            </Link>

            <div className="navigationDropDown">
              <div className="dropDownTip"/>
              <div className="dropDownUsabilityFillter"/>
              <Link to="/law-enforcement/#feature1" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">SMS Satisfaction Surveys</div>
              </Link>
              <Link to="/law-enforcement/#feature2" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Follow-Up Tasks</div>
              </Link>
              <Link to="/law-enforcement/#feature3" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Positive Feedback Board for Officers</div>
              </Link>
              <Link to="/law-enforcement/#feature7" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Automatic Email Digests</div>
              </Link>
              <Link to="/law-enforcement/#feature4" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Text the Chief</div>
              </Link>
              <Link to="/law-enforcement/#feature5" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Citizen Positive Satisfaction Score</div>
              </Link>
              <Link to="/law-enforcement/#feature6" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Video Reporting Officer</div>
              </Link>
            </div>
          </div>

          <div className="navigationItem navigationIndustryEMS">
            <Link to="/ems/" className="navigationSegment" activeClassName="selected">
              <div className="navigationTitle">EMS</div>
            </Link>

            <div className="navigationDropDown">
              <div className="dropDownTip"/>
              <div className="dropDownUsabilityFillter"/>
              <Link to="/ems/#feature1" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Telehealth Response</div>
              </Link>
              <Link to="/ems/#feature2" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Low-Acuity Services</div>
              </Link>
              <Link to="/ems/#feature3" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Text Based Surveys</div>
              </Link>
              <Link to="/ems/#feature4" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Actionable Analytics</div>
              </Link>
            </div>
          </div>

          <div className="navigationItem navigationIndustryFire">
            <Link to="/fire/" className="navigationSegment" activeClassName="selected">
              <div className="navigationTitle">Fire</div>
            </Link>

            <div className="navigationDropDown">
              <div className="dropDownTip"/>
              <div className="dropDownUsabilityFillter"/>
              <Link to="/fire/#feature1" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Reduce Risk</div>
              </Link>
              <Link to="/fire/#feature2" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Automate Communication</div>
              </Link>
              <Link to="/fire/#feature3" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Performance Insights</div>
              </Link>
            </div>
          </div>

          <div className="navigationItem navigationAbout">
            <Link to="/news/" className="navigationSegment" activeClassName="selected">
              <div className="navigationTitle">News</div>
            </Link>

            <div className="navigationDropDown">
              <div className="dropDownTip"/>
              <div className="dropDownUsabilityFillter"/>
              {/*<Link to="/about/" className="dropDownItem" activeClassName="selected">*/}
              {/*  <div className="itemTitle">Company</div>*/}
              {/*</Link>*/}
              {/*<Link to="/events/" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Events</div>
              </Link>*/}
              <Link to="/news/" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">News</div>
              </Link>
              <Link to="/blog/" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Posts</div>
              </Link>
              {/*<Link to="/partners/" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Partners</div>
              </Link>*/}
              <Link to="/contact/" className="dropDownItem" activeClassName="selected">
                <div className="itemTitle">Contact Us</div>
              </Link>
            </div>
          </div>
        </div>

        <div className="rightActions">
          <a href="https://secure.cuehit.net/auth" className="actionItem secondary">
            <div className="actionTitle">Log In</div>
          </a>

          <Link to="/contact" className="actionItem primary">
            <div className="actionTitle">Request a Demo</div>
          </Link>
        </div>
      </div>

    </header>
  </div>
}
